import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Button, Typography } from "@mui/material";
import { styles } from "./styles";
import { SubscriptionTier } from "../../proto/api_pb";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";
import { useContext } from "react";
import { UserDetailsContext } from "../../contexts";
import { minorPlanFeatures } from "./helper";

export const MinorPlanDetails: React.FC<{ isYearly: boolean }> = ({
  isYearly,
}) => {
  const { subscriptionTier } = useContext(UserDetailsContext);
  const { getCustomerPortalLink } = useGetCustomerPortalLink();
  const isUpgradePlanAvailable =
    subscriptionTier < SubscriptionTier.SUBSCRIPTION_TIER_MINOR;

  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "40px" }} variant="h4">
          {isYearly ? "$47.99" : "$4.99"}
        </Typography>
        <Box sx={{ paddingLeft: "10px" }}>
          <Typography variant="body2">per</Typography>
          <Typography variant="body2">{isYearly ? "year" : "month"}</Typography>
        </Box>
      </Box>

      {isUpgradePlanAvailable && (
        <Button
          onClick={getCustomerPortalLink}
          sx={{ ...styles.button, width: "100%", margin: 0 }}
        >
          Upgrade
        </Button>
      )}

      <ul style={styles.minorPlanFeatureUl}>
        {minorPlanFeatures.map((feature, index) => (
          <li key={index} style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            {feature}
          </li>
        ))}
      </ul>
    </Box>
  );
};
